module.exports = __webpack_public_path__ + "img/track_history.708342f8.svg";